import { render, staticRenderFns } from "./SuggestionPage1.vue?vue&type=template&id=0136be91"
import script from "./SuggestionPage1.vue?vue&type=script&lang=js"
export * from "./SuggestionPage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports